<template>
    <app-layout>
        <template #header>
            <AppHead title="Account Finance" />
            <div class="row py-2">
                <div class="col-12 col-md-6 col-lg-8 d-flex align-items-center">
                    <h2 class="title">Account Finance</h2>
                </div>
            </div>
            <flash-messages />
        </template>

        <div class="py-2">
            <div class="bg-white p-3">
                <ul class="nav nav-tabs nav-justified">
                    <li class="nav-item">
                        <inertia-link :class="tab == 'history' ? 'nav-link active' : 'nav-link'"
                            :href="route('mtd.history', 'history')">History</inertia-link>
                    </li>
                    <li class="nav-item" v-if="!is_linked">
                        <inertia-link :class="tab == 'payouts' ? 'nav-link active' : 'nav-link'"
                            :href="route('mtd.history', 'payouts')">Payout History</inertia-link>
                    </li>
                    <li class="nav-item">
                        <inertia-link :class="tab == 'cash' ? 'nav-link active' : 'nav-link'"
                            :href="route('mtd.history', 'cash')">Cash/Checks</inertia-link>
                    </li>
                    <li class="nav-item">
                        <inertia-link :class="tab == 'salestax' ? 'nav-link active' : 'nav-link'"
                            :href="route('mtd.history', 'salestax')">Tax Collected</inertia-link>
                    </li>
                </ul>
                <card class="border-top-0">
                    <card title="Snapshot" v-if="summary">
                        <div class="row">
                            <div class="col-sm-4">
                                <h5 v-if="has_linked">Total</h5>
                                <p class="my-0">
                                    <span class="font-weight-bold">Today Orders:</span> <span
                                        class="float-right amount-detail" @click="filterSet('today', 'orders')"> {{
                                            formatDollars(summary.totalTodayOrders) }} <i class="fa fa-filter"></i></span>
                                </p>
                                <p class="my-0">
                                    <span class="font-weight-bold">Today Payments:</span> <span
                                        class="float-right amount-detail" @click="filterSet('today', 'payments')"> {{
                                            formatDollars(summary.totalTodayPayments) }} <i class="fa fa-filter"></i></span>
                                </p>
                                <p class="my-0">
                                    <span class="font-weight-bold">Yesterday Orders:</span> <span
                                        class="float-right amount-detail" @click="filterSet('yesterday', 'orders')"> {{
                                            formatDollars(summary.totalYesterdayOrders) }} <i class="fa fa-filter"></i></span>
                                </p>
                                <p class="my-0">
                                    <span class="font-weight-bold">Yesterday Payments:</span> <span
                                        class="float-right amount-detail" @click="filterSet('yesterday', 'payments')"> {{
                                            formatDollars(summary.totalYesterdayPayments) }} <i class="fa fa-filter"></i></span>
                                </p>
                                <p class="my-0">
                                    <span class="font-weight-bold">This week Orders:</span> <span
                                        class="float-right amount-detail" @click="filterSet('week', 'orders')"> {{
                                            formatDollars(summary.totalThisWeekOrders) }} <i class="fa fa-filter"></i></span>
                                </p>
                                <p class="my-0">
                                    <span class="font-weight-bold">This week Payments:</span> <span
                                        class="float-right amount-detail" @click="filterSet('week', 'payments')"> {{
                                            formatDollars(summary.totalThisWeekPayments) }} <i class="fa fa-filter"></i></span>
                                </p>
                                <p class="my-0">
                                    <span class="font-weight-bold">Last week Orders:</span> <span
                                        class="float-right amount-detail" @click="filterSet('lastweek', 'orders')"> {{
                                            formatDollars(summary.totalLastWeekOrders) }} <i class="fa fa-filter"></i></span>
                                </p>
                                <p class="my-0">
                                    <span class="font-weight-bold">Last week Payments:</span> <span
                                        class="float-right amount-detail" @click="filterSet('lastweek', 'payments')"> {{
                                            formatDollars(summary.totalLastWeekPayments) }} <i class="fa fa-filter"></i></span>
                                </p>

                                <p class="my-0">
                                    <span class="font-weight-bold">Pending TU Payments:</span> <span class="float-right"> {{
                                        formatDollars(summary.customerAccountBalance) }} </span>
                                </p>
                            </div>
                            <div v-if="has_linked" v-for="truck in summary.bytruck" class="col-sm-4">
                                <h5>{{ truck.company_name }}</h5>

                                <p class="my-0">
                                    <span class="font-weight-bold">&nbsp;</span> <span class="float-right amount-detail"
                                        @click="filterSet('today', 'orders', truck.id)"> {{
                                            formatDollars(truck.totalTodayOrders) }} <i class="fa fa-filter"></i></span>
                                </p>
                                <p class="my-0">
                                    <span class="font-weight-bold">&nbsp;</span> <span class="float-right amount-detail"
                                        @click="filterSet('today', 'payments', truck.id)"> {{
                                            formatDollars(truck.totalTodayPayments) }} <i class="fa fa-filter"></i></span>
                                </p>
                                <p class="my-0">
                                    <span class="font-weight-bold">&nbsp;</span> <span class="float-right amount-detail"
                                        @click="filterSet('yesterday', 'orders', truck.id)"> {{
                                            formatDollars(truck.totalYesterdayOrders) }} <i class="fa fa-filter"></i></span>
                                </p>
                                <p class="my-0">
                                    <span class="font-weight-bold">&nbsp;</span> <span class="float-right amount-detail"
                                        @click="filterSet('yesterday', 'payments', truck.id)"> {{
                                            formatDollars(truck.totalYesterdayPayments) }} <i class="fa fa-filter"></i></span>
                                </p>
                                <p class="my-0">
                                    <span class="font-weight-bold">&nbsp;</span> <span class="float-right amount-detail"
                                        @click="filterSet('week', 'orders', truck.id)"> {{
                                            formatDollars(truck.totalThisWeekOrders) }} <i class="fa fa-filter"></i></span>
                                </p>
                                <p class="my-0">
                                    <span class="font-weight-bold">&nbsp;</span> <span class="float-right amount-detail"
                                        @click="filterSet('week', 'payments', truck.id)"> {{
                                            formatDollars(truck.totalThisWeekPayments) }} <i class="fa fa-filter"></i></span>
                                </p>
                                <p class="my-0">
                                    <span class="font-weight-bold">&nbsp;</span> <span class="float-right amount-detail"
                                        @click="filterSet('lastweek', 'orders', truck.id)"> {{
                                            formatDollars(truck.totalLastWeekOrders) }} <i class="fa fa-filter"></i></span>
                                </p>
                                <p class="my-0">
                                    <span class="font-weight-bold">&nbsp;</span> <span class="float-right amount-detail"
                                        @click="filterSet('lastweek', 'payments', truck.id)"> {{
                                            formatDollars(truck.totalLastWeekPayments) }} <i class="fa fa-filter"></i></span>
                                </p>

                                <p class="my-0">
                                    <span class="font-weight-bold">&nbsp;</span> <span class="float-right"> {{
                                        formatDollars(truck.customerAccountBalance) }} </span>
                                </p>
                            </div>
                        </div>
                    </card>

                    <card title="Search" class="my-3">

                        <div class="row">
                            <div class="form-group col-sm-3">
                                <jet-label for="start_date" value="From" />
                                <Calendar v-model="selected_start_date" class="w-100" id="start_date" :showIcon="true"
                                    :selectOtherMonths="true" />
                                <br /><br />
                                <template v-if="has_linked" v-for="truck in summary.bytruck">
                                    <input type="checkbox" :value="truck.id" v-model="selected_trucks" /> {{
                                        truck.company_name }}<br />
                                </template>
                            </div>
                            <div class="form-group col-sm-3">
                                <jet-label for="end_date" value="To" />
                                <Calendar v-model="selected_end_date" class="w-100" id="end_date" :showIcon="true"
                                    :selectOtherMonths="true" />
                            </div>


                            <div class="col-sm-6">
                                <p class="my-0">
                                    <span class="font-weight-bold">Orders</span> <span class="float-right amount-detail"
                                        @click="filterType('orders')"> {{ formatDollars(totals.total_orders) }} <i
                                            class="fa fa-filter"></i></span>
                                </p>
                                <p class="my-0">
                                    <span class="font-weight-bold">Payments:</span> <span class="float-right amount-detail"
                                        @click="filterType('payments')"> {{ formatDollars(totals.total_payments) }} <i
                                            class="fa fa-filter"></i></span>
                                </p>
                                <hr />
                                <p class="my-0">
                                    <span class="font-weight-bold">Orders Added to Balance:</span> <span
                                        class="float-right amount-detail" @click="filterType('orders', 'balance')"> {{
                                            formatDollars(totals.total_orders_balance) }} <i class="fa fa-filter"></i></span>
                                </p>
                                <p class="my-0">
                                    <span class="font-weight-bold">Orders Paid:</span> <span
                                        class="float-right amount-detail" @click="filterType('order_paid')"> {{
                                            formatDollars(totals.total_orders_paid) }} <i class="fa fa-filter"></i></span>
                                </p>
                                <p class="my-0">
                                    <span class="font-weight-bold">Account Balance Payments:</span> <span
                                        class="float-right amount-detail" @click="filterType('payments_balance')"> {{
                                            formatDollars(totals.total_payments_balance) }} <i class="fa fa-filter"></i></span>
                                </p>
                                <hr />
                                <p class="my-0">
                                    <span class="font-weight-bold">CC/ACH:</span> <span class="float-right amount-detail"
                                        @click="filterType('payments', 'ccach')"> {{ formatDollars(totals.total_ccach) }} <i
                                            class="fa fa-filter"></i></span>
                                </p>
                                <p class="my-0">
                                    <span class="font-weight-bold">Cash:</span> <span class="float-right amount-detail"
                                        @click="filterType('payments', 'cash')"> {{ formatDollars(totals.total_cash) }} <i
                                            class="fa fa-filter"></i></span>
                                </p>
                                <p class="my-0">
                                    <span class="font-weight-bold">Check:</span> <span class="float-right amount-detail"
                                        @click="filterType('payments', 'check')"> {{ formatDollars(totals.total_check) }} <i
                                            class="fa fa-filter"></i></span>
                                </p>
                            </div>
                        </div>
                        <hr />
                        <div class="form-row">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" id="check_order" type="checkbox" value="order"
                                    v-model="selected_types" />
                                <label class="form-check-label" for="check_order">Orders</label>
                            </div>

                            <div class="form-check form-check-inline">
                                <input class="form-check-input" id="check_payment" type="checkbox" value="payment"
                                    v-model="selected_types" />
                                <label class="form-check-label" for="check_payment">Payments</label>
                            </div>
                        </div>
                        <hr />
                        Payment Type
                        <div class="form-row">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" id="check_cc" type="checkbox" value="Credit Card"
                                    v-model="selected_payment_types" />
                                <label class="form-check-label" for="check_cc">Credit Card</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" id="check_ach" type="checkbox" value="ACH"
                                    v-model="selected_payment_types" />
                                <label class="form-check-label" for="check_ach">ACH</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" id="check_cash" type="checkbox" value="Cash"
                                    v-model="selected_payment_types" />
                                <label class="form-check-label" for="check_cash">Cash</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" id="check_check" type="checkbox" value="Check"
                                    v-model="selected_payment_types" />
                                <label class="form-check-label" for="check_check">Check</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" id="check_balance" type="checkbox" value="Account Balance"
                                    v-model="selected_payment_types" />
                                <label class="form-check-label" for="check_balance">Account Balance</label>
                            </div>
                        </div>
                        <hr />
                        <label for="stripe_payout">Payout (clears other filters)</label>
                        <select class="form-control" id="stripe_payout" v-model="selected_payout_id">
                            <option v-for="payout in payouts" :key="payout.id" :value="payout.id">
                                {{ formatDollars(payout.amount) }} on {{ moment(payout.date).format('M/D/YY h:mm A') }}
                            </option>
                        </select>
                        <hr />
                        <jet-button class="px-5" btnStyle="success" :disable="loading"
                            @click="filter()">Search</jet-button>
                    </card>
                    <h3>{{ history.length }} Results</h3>
                    <div>
                        <p class="my-1 text-right" v-if="history.length">
                            <jet-button class="px-2 btn-sm" btnStyle="success" @click="exportHistory()"
                                icon="fa fa-download">Export</jet-button>
                        </p>
                        <p class="my-0">
                            <span class="font-weight-bold">Amount</span> <span class="float-right"> {{
                                formatDollars(totals.results_total) }}</span>
                        </p>
                        <p class="my-0">
                            <span class="font-weight-bold">Net:</span> <span class="float-right"> {{
                                formatDollars(totals.results_total_net) }}</span>
                        </p>
                    </div>
                    <br />
                    <DataTable :value="history" ref="detailsTable" class="p-datatable-sm" responsiveLayout="stack"
                        stripedRows v-model:expandedRows="expandedRows">
                        <Column field="created_at" header="Date">
                            <template #body="slotProps">
                                {{ moment(slotProps.data.date).format('M/D/YY h:mm A') }}
                            </template>
                        </Column>
                        <Column field="amount" header="Amount" headerClass="header-right" class="table-right">
                            <template #body="slotProps">
                                {{ formatDollars(slotProps.data.amount) }}
                            </template>
                        </Column>
                        <Column field="netAmount" header="Net" headerClass="header-right" class="table-right">
                            <template #body="slotProps">
                                {{ formatDollars(slotProps.data.netAmount) }}
                            </template>
                        </Column>
                        <Column field="data.type" header="Item">
                            <template #body="slotProps">
                                <inertia-link v-if="slotProps.data.link"
                                    :href="route(slotProps.data.link[0], slotProps.data.link[1])" class="item-link">
                                    {{ slotProps.data.data.type }} #{{ slotProps.data.data.id }} {{
                                        slotProps.data.data.customer_name }}
                                </inertia-link>
                            </template>
                        </Column>
                        <Column field="truck" header="Truck" v-if="has_linked" />
                        <template #expansion="slotProps">
                            <div class="transaction-details w-100">
                                <template v-if="slotProps.data.payouts && slotProps.data.payouts.length > 0">
                                    <table>
                                        <tr class="d-flex justify-content-between" v-for="payout in slotProps.data.payouts">
                                            <td>Payout</td>
                                            <td>
                                                {{ formatDollars(payout.net) }} on {{
                                                    moment(payout.available_on).format('M/D') }}
                                            </td>
                                        </tr>
                                    </table>
                                </template>
                            </div>
                        </template>
                    </DataTable>

                </card>

            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import FlashMessages from '@/Shared/FlashMessages'
import JetInput from '@/Jetstream/Input'
import JetCheckbox from '@/Jetstream/Checkbox'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'
import Icon from '@/Shared/Icon'
import moment from 'moment'
import Calendar from 'primevue/calendar';

export default {
    components: {
        AppLayout,
        FlashMessages,
        JetInput,
        JetCheckbox,
        JetInputError,
        JetLabel,
        Icon,
        Calendar,
    },
    props: {
        tab: String,
        has_linked: Boolean,
        is_linked: Boolean,
        current: Boolean,
        monthText: String,
        month: Number,
        year: Number,
        months: Array,
        summary: Object,
        history: Array,
        totals: Object,
        start_date: String,
        end_date: String,
        trucks: Array,
        types: Array,
        selected_payment_types: Array,
        payouts: Array,
        payout_id: Number
    },
    data() {
        return {
            selected_start_date: this.start_date ? new Date(this.start_date) : null,
            selected_end_date: this.end_date ? new Date(this.end_date) : null,
            selected_types: this.types,
            selected_payment_types: this.selected_payment_types,
            selected_trucks: this.trucks,
            selected_payout_id: this.payout_id,
            expandedRows: [],
            loading: false,
        }
    },
    created: function () {
        this.moment = moment;
    },
    methods: {
        filterSet(period, type, truck) {
            let now = null;
            switch (period) {
                case 'today':
                    now = moment().startOf('day');
                    this.selected_start_date = now.clone().toDate();
                    this.selected_end_date = null;
                    break;
                case 'yesterday':
                    now = moment().subtract(1, 'days').startOf('day');
                    this.selected_start_date = now.clone().toDate();
                    this.selected_end_date = now.clone().add(1, 'days').toDate();
                    break;
                case 'week':
                    now = moment.utc().startOf('day').startOf('isoWeek');
                    this.selected_start_date = now.clone().toDate();
                    this.selected_end_date = now.clone().add(7, 'days').toDate();
                    break;
                case 'lastweek':
                    now = moment.utc().startOf('day').startOf('isoWeek').subtract(7, 'days');
                    this.selected_start_date = now.clone().toDate();
                    this.selected_end_date = now.clone().add(7, 'days').toDate();
                    break;
            }

            if (!truck) {
                this.selected_trucks = [];
            } else {
                this.selected_trucks = [truck];
            }

            this.filterType(type);
        },
        filterType(type, payment_type) {
            this.selected_payout_id = null;

            switch (type) {
                case 'orders':
                    this.selected_types = ['order'];
                    this.selected_payment_types = ['Credit Card', 'ACH', 'Cash', 'Check', 'Account Balance'];
                    break;

                case 'order_paid':
                    this.selected_types = ['order'];
                    this.selected_payment_types = ['Credit Card', 'ACH', 'Cash', 'Check'];
                    break;

                case 'payments':
                case 'payments_balance':
                    this.selected_types = ['payment'];
                    this.selected_payment_types = ['Credit Card', 'ACH', 'Cash', 'Check'];
                    break;
            }

            if (payment_type) {
                this.filterPaymentType(payment_type);
            } else {
                this.filter();
            }
        },
        filterPaymentType(type) {
            this.selected_payout_id = null;

            if (type == 'ccach') {
                this.selected_payment_types = ['Credit Card', 'ACH'];
            } else {
                this.selected_payment_types = [type];
            }

            this.filter();
        },
        filter() {
            if (this.selected_payout_id) {
                this.selected_types = ['order', 'payment'];
                this.selected_payment_types = ['Credit Card', 'ACH'];
            }
            this.loading = true;
            this.$inertia.visit(route('mtd.history', {
                start_date: this.selected_start_date ? moment(this.selected_start_date).format('YYYY-MM-DD') : null,
                end_date: this.selected_end_date ? moment(this.selected_end_date).format('YYYY-MM-DD') : null,
                trucks: this.selected_trucks,
                type: this.selected_types,
                selected_payment_types: this.selected_payment_types,
                payout_id: this.selected_payout_id,
            }), {
                preserveScroll: true,
                onFinish: () => this.loading = false,
            })
        },
        selectMonth: function (e) {
            let month = this.months[e.target.value];

            this.$inertia.visit(route('mtd.salestax.date', { year: month.year, month: month.monthNum }));
        },
        exportHistory() {
            if (this.selected_payout_id) {
                this.selected_types = ['order', 'payment'];
                this.selected_payment_types = ['Credit Card', 'ACH'];
            }
            this.loading = true;
            axios.post(route('mtd.history.export'), {
                start_date: this.selected_start_date ? moment(this.selected_start_date).format('YYYY-MM-DD') : null,
                end_date: this.selected_end_date ? moment(this.selected_end_date).format('YYYY-MM-DD') : null,
                trucks: this.selected_trucks,
                type: this.selected_types,
                selected_payment_types: this.selected_payment_types,
                payout_id: this.selected_payout_id,
            }, {
                responseType: 'blob',
                onFinish: () => this.loading = false,
            }).then(response => {
                this.downloadResponse(response)
            })
        }
    }
}
</script>

<style>
.header-right .p-column-header-content {
    justify-content: end;
}

.p-datatable .p-datatable-tbody>tr>td.table-right {
    text-align: right;
}

.amount-detail {
    cursor: pointer;
    color: blue;
}

.amount-detail i {
    font-size: 9px;
}

.item-link {
    text-transform: capitalize;
}
</style>